import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrStaticPlaysTotal } from '@/api/routes/static-stat/types';

import { fetchStaticAggrTotal } from './actionCreators';

interface InitialState {
  devices_count: number,
  play_secs: number,
  mileage: number,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  devices_count: 0,
  play_secs: 0,
  mileage: 0,
  isLoading: false,
  error: '',
};

export const staticAggrTotalSlice = createSlice({
  name: 'staticAggrTotalSlice',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStaticAggrTotal.fulfilled.type]: (state, action: PayloadAction<AggrStaticPlaysTotal>) => {
      state.isLoading = false;
      state.error = '';
      state.devices_count = action.payload.devices_count;
      state.play_secs = action.payload.play_secs;
      state.mileage = action.payload.mileage;
    },
    [fetchStaticAggrTotal.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticAggrTotal.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default staticAggrTotalSlice.reducer;
